// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-container-T5urx {
  padding: 0 32px 20px;
}

.help-toolbar-YouTs {
  height: 52px;
  align-items: center;
}

.help-title_title-q0lzG {
  font-size: var(--text-lg);
}

.help-content-QY8cg {
  display: grid;
  gap: 24px;
  overflow: auto;
  margin-top: 0px;
}

.help-column-Apc6q {
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
}

.help-outlineCard-cZ_UH {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px;
}

/* Headers */
.help-sectionHeader-Uz436 {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.help-sectionHeaderWithIcon-MMctp {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 8px;
}

.help-headerIcon-QmHsC {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: var(--radius-xl);
  background-color: var(--color-blue-50);
  color: var(--color-blue-500);
  font-size: var(--text-2xl);
  cursor: default;
  flex-shrink: 0;
}

.help-sectionTitle-p8fxR {
  font-size: var(--text-base);
  font-weight: var(--font-weight-semibold);
  color: var(--color-neutral-700);
  letter-spacing: var(--tracking-tight);
}

.help-sectionSubtitle-LoEF8 {
  font-size: var(--text-sm);
  color: var(--color-neutral-500);
  line-height: var(--leading-normal);
}

/* FAQ Section */
.help-faqCard-PzYTx {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px 0 12px;
}

.help-faqHeader-PQ9Ry {
  padding: 0 24px;
}

.help-faqList-roNMU {
  display: flex;
  flex-direction: column;
  padding: 0 12px;
}

.help-faqItem-CdCu5 {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid var(--color-neutral-100);
}

.help-faqItem-CdCu5:last-child {
  border-bottom: none;
}

.help-faqQuestion-Jn0l8 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 12px;
  border-radius: var(--radius-xl);
  color: var(--color-neutral-800);
  font-size: var(--text-base);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease;
}

.help-faqQuestion-Jn0l8:hover {
  background-color: var(--color-neutral-50);
  color: var(--color-blue-500);
}

.help-faqQuestion-Jn0l8:hover .help-faqIcon-SPpva {
  color: var(--color-blue-500);
}

.help-faqIcon-SPpva {
  color: var(--color-neutral-400);
  font-size: var(--text-2xl);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.help-faqIconExpanded-SuUdx {
  transform: rotate(180deg);
}

.help-faqAnswerWrapper-GvPOb {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.3s ease;
}

.help-faqAnswer-HkKiL {
  padding: 0 16px;
  color: var(--color-neutral-600);
  font-size: var(--text-sm);
  line-height: var(--leading-relaxed);
  overflow: hidden;
  transition: padding 300ms linear;
}

.help-faqAnswerExpanded-P76p1 {
  grid-template-rows: 1fr;
}

.help-faqAnswerExpanded-P76p1 .help-faqAnswer-HkKiL {
  padding-top: 8px;
  padding-bottom: 20px;
}

/* Contact Section */
.help-contactList-L5xuF {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.help-contactItem-PEzVb {
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 0 -12px;
  padding: 12px;
  border-radius: var(--radius-xl);
  transition: background-color 0.2s ease;
}

.help-contactItem-PEzVb:hover {
  background-color: var(--color-neutral-50);
}

.help-contactIcon-bdSzg {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: var(--radius-lg);
  background-color: var(--color-blue-50);
  color: var(--color-blue-500);
  font-size: var(--text-xl);
  transition: transform 0.3s ease, background-color 0.3s ease;
}

.help-contactItem-PEzVb:hover .help-contactIcon-bdSzg {
  background-color: var(--color-blue-100);
}

.help-contactText-yV4CY {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.help-contactLabel-OZujG {
  color: var(--color-neutral-600);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-medium);
}

.help-contactValue-UqVnc {
  color: var(--color-blue-500);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-medium);
  text-decoration: none;
  transition: color 0.2s ease;
}

.help-contactValue-UqVnc:hover {
  text-decoration: underline;
}

/* Schedule Section */
.help-scheduleList-N03vH {
  display: flex;
  flex-direction: column;
}

.help-scheduleItem-SRwWT {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 -12px;
  padding: 16px 12px;
  border-bottom: 1px solid var(--color-neutral-100);
  border-radius: var(--radius-lg);
  transition: background-color 0.2s ease;
}

.help-scheduleItem-SRwWT:last-child {
  border-bottom: none;
}

.help-scheduleItem-SRwWT:hover {
  background-color: var(--color-neutral-50);
}

.help-scheduleDay-nVuqM {
  color: var(--color-neutral-600);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-medium);
}

.help-scheduleHours-AYZP3 {
  color: var(--color-neutral-800);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-semibold);
}

.help-scheduleDisclaimer-aqf1U {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 12px;
  padding: 12px 16px;
  border: 1px solid var(--color-blue-100);
  border-radius: var(--radius-xl);
  background-color: var(--color-blue-50);
  color: var(--color-neutral-600);
  font-size: var(--text-sm);
  line-height: var(--leading-normal);
}

.help-disclaimerIcon-hLzKs {
  margin-top: 2px;
  color: var(--color-blue-500);
  font-size: var(--text-lg);
  flex-shrink: 0;
}

@media (min-width: 1024px) {

  .help-content-QY8cg {
    grid-template-columns: 1fr 420px;
    overflow: hidden;
  }

  .help-faqCard-PzYTx {
    overflow: hidden;
  }

  .help-faqList-roNMU {
    flex: 1;
    overflow: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/help/help.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,sCAAsC;EACtC,4BAA4B;EAC5B,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA,gBAAgB;AAChB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,2BAA2B;EAC3B,sCAAsC;EACtC,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,mCAAmC;EACnC,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,aAAa;EACb,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,sCAAsC;EACtC,4BAA4B;EAC5B,yBAAyB;EACzB,2DAA2D;AAC7D;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,sCAAsC;EACtC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,iDAAiD;EACjD,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,+BAA+B;EAC/B,sCAAsC;EACtC,+BAA+B;EAC/B,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE;IACE,gCAAgC;IAChC,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,OAAO;IACP,cAAc;EAChB;AACF","sourcesContent":[".container {\n  padding: 0 32px 20px;\n}\n\n.toolbar {\n  height: 52px;\n  align-items: center;\n}\n\n.title_title {\n  font-size: var(--text-lg);\n}\n\n.content {\n  display: grid;\n  gap: 24px;\n  overflow: auto;\n  margin-top: 0px;\n}\n\n.column {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  height: 100%;\n}\n\n.outlineCard {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 24px;\n}\n\n/* Headers */\n.sectionHeader {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.sectionHeaderWithIcon {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 8px;\n}\n\n.headerIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: var(--radius-xl);\n  background-color: var(--color-blue-50);\n  color: var(--color-blue-500);\n  font-size: var(--text-2xl);\n  cursor: default;\n  flex-shrink: 0;\n}\n\n.sectionTitle {\n  font-size: var(--text-base);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-neutral-700);\n  letter-spacing: var(--tracking-tight);\n}\n\n.sectionSubtitle {\n  font-size: var(--text-sm);\n  color: var(--color-neutral-500);\n  line-height: var(--leading-normal);\n}\n\n/* FAQ Section */\n.faqCard {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 24px 0 12px;\n}\n\n.faqHeader {\n  padding: 0 24px;\n}\n\n.faqList {\n  display: flex;\n  flex-direction: column;\n  padding: 0 12px;\n}\n\n.faqItem {\n  display: flex;\n  flex-direction: column;\n  border-bottom: 1px solid var(--color-neutral-100);\n}\n\n.faqItem:last-child {\n  border-bottom: none;\n}\n\n.faqQuestion {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 12px;\n  border-radius: var(--radius-xl);\n  color: var(--color-neutral-800);\n  font-size: var(--text-base);\n  font-weight: var(--font-weight-medium);\n  cursor: pointer;\n  user-select: none;\n  transition: all 0.2s ease;\n}\n\n.faqQuestion:hover {\n  background-color: var(--color-neutral-50);\n  color: var(--color-blue-500);\n}\n\n.faqQuestion:hover .faqIcon {\n  color: var(--color-blue-500);\n}\n\n.faqIcon {\n  color: var(--color-neutral-400);\n  font-size: var(--text-2xl);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.faqIconExpanded {\n  transform: rotate(180deg);\n}\n\n.faqAnswerWrapper {\n  display: grid;\n  grid-template-rows: 0fr;\n  transition: grid-template-rows 0.3s ease;\n}\n\n.faqAnswer {\n  padding: 0 16px;\n  color: var(--color-neutral-600);\n  font-size: var(--text-sm);\n  line-height: var(--leading-relaxed);\n  overflow: hidden;\n  transition: padding 300ms linear;\n}\n\n.faqAnswerExpanded {\n  grid-template-rows: 1fr;\n}\n\n.faqAnswerExpanded .faqAnswer {\n  padding-top: 8px;\n  padding-bottom: 20px;\n}\n\n/* Contact Section */\n.contactList {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.contactItem {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin: 0 -12px;\n  padding: 12px;\n  border-radius: var(--radius-xl);\n  transition: background-color 0.2s ease;\n}\n\n.contactItem:hover {\n  background-color: var(--color-neutral-50);\n}\n\n.contactIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-lg);\n  background-color: var(--color-blue-50);\n  color: var(--color-blue-500);\n  font-size: var(--text-xl);\n  transition: transform 0.3s ease, background-color 0.3s ease;\n}\n\n.contactItem:hover .contactIcon {\n  background-color: var(--color-blue-100);\n}\n\n.contactText {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.contactLabel {\n  color: var(--color-neutral-600);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-medium);\n}\n\n.contactValue {\n  color: var(--color-blue-500);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-medium);\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.contactValue:hover {\n  text-decoration: underline;\n}\n\n/* Schedule Section */\n.scheduleList {\n  display: flex;\n  flex-direction: column;\n}\n\n.scheduleItem {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 -12px;\n  padding: 16px 12px;\n  border-bottom: 1px solid var(--color-neutral-100);\n  border-radius: var(--radius-lg);\n  transition: background-color 0.2s ease;\n}\n\n.scheduleItem:last-child {\n  border-bottom: none;\n}\n\n.scheduleItem:hover {\n  background-color: var(--color-neutral-50);\n}\n\n.scheduleDay {\n  color: var(--color-neutral-600);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-medium);\n}\n\n.scheduleHours {\n  color: var(--color-neutral-800);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-semibold);\n}\n\n.scheduleDisclaimer {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-top: 12px;\n  padding: 12px 16px;\n  border: 1px solid var(--color-blue-100);\n  border-radius: var(--radius-xl);\n  background-color: var(--color-blue-50);\n  color: var(--color-neutral-600);\n  font-size: var(--text-sm);\n  line-height: var(--leading-normal);\n}\n\n.disclaimerIcon {\n  margin-top: 2px;\n  color: var(--color-blue-500);\n  font-size: var(--text-lg);\n  flex-shrink: 0;\n}\n\n@media (min-width: 1024px) {\n\n  .content {\n    grid-template-columns: 1fr 420px;\n    overflow: hidden;\n  }\n\n  .faqCard {\n    overflow: hidden;\n  }\n\n  .faqList {\n    flex: 1;\n    overflow: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `help-container-T5urx`,
	"toolbar": `help-toolbar-YouTs`,
	"title_title": `help-title_title-q0lzG`,
	"content": `help-content-QY8cg`,
	"column": `help-column-Apc6q`,
	"outlineCard": `help-outlineCard-cZ_UH`,
	"sectionHeader": `help-sectionHeader-Uz436`,
	"sectionHeaderWithIcon": `help-sectionHeaderWithIcon-MMctp`,
	"headerIcon": `help-headerIcon-QmHsC`,
	"sectionTitle": `help-sectionTitle-p8fxR`,
	"sectionSubtitle": `help-sectionSubtitle-LoEF8`,
	"faqCard": `help-faqCard-PzYTx`,
	"faqHeader": `help-faqHeader-PQ9Ry`,
	"faqList": `help-faqList-roNMU`,
	"faqItem": `help-faqItem-CdCu5`,
	"faqQuestion": `help-faqQuestion-Jn0l8`,
	"faqIcon": `help-faqIcon-SPpva`,
	"faqIconExpanded": `help-faqIconExpanded-SuUdx`,
	"faqAnswerWrapper": `help-faqAnswerWrapper-GvPOb`,
	"faqAnswer": `help-faqAnswer-HkKiL`,
	"faqAnswerExpanded": `help-faqAnswerExpanded-P76p1`,
	"contactList": `help-contactList-L5xuF`,
	"contactItem": `help-contactItem-PEzVb`,
	"contactIcon": `help-contactIcon-bdSzg`,
	"contactText": `help-contactText-yV4CY`,
	"contactLabel": `help-contactLabel-OZujG`,
	"contactValue": `help-contactValue-UqVnc`,
	"scheduleList": `help-scheduleList-N03vH`,
	"scheduleItem": `help-scheduleItem-SRwWT`,
	"scheduleDay": `help-scheduleDay-nVuqM`,
	"scheduleHours": `help-scheduleHours-AYZP3`,
	"scheduleDisclaimer": `help-scheduleDisclaimer-aqf1U`,
	"disclaimerIcon": `help-disclaimerIcon-hLzKs`
};
export default ___CSS_LOADER_EXPORT___;
